const validateFile = (file) => {
  if (!file.type.startsWith("image/")) return false;
  return true;
};
const resizeImage = (imageSrc, fixedSize) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = imageSrc;
    image.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      let width, height;
      if (image.width <= image.height) {
        width = fixedSize;
        height = (image.height / image.width) * fixedSize;
      } else {
        height = fixedSize;
        width = (image.width / image.height) * fixedSize;
      }
      canvas.width = Math.round(width);
      canvas.height = Math.round(height);
      ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
      const mimeType = imageSrc?.type || "image/png"; // Ex: "image/jpeg" ou "image/png"
      const outputExt = mimeType.split("/")[1]; // "jpeg" ou "png"
      canvas.toBlob((blob) => {
        if (!blob) return reject(new Error("Falha ao criar blob"));
        const dataUrl = canvas.toDataURL(mimeType);
        resolve({ src: dataUrl, blob, ext: outputExt });
      }, mimeType);
    };
    image.onerror = reject;
  });
};
//função de crop de imagem centralizado
const cropImageCenter = (imageSrc, sizeOutput) => {
  const size = sizeOutput;
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = imageSrc;
    image.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const minSide = Math.min(image.width, image.height);
      const startX = (image.width - minSide) / 2;
      const startY = (image.height - minSide) / 2;
      canvas.width = size;
      canvas.height = size;
      ctx.drawImage(
        image,
        startX,
        startY,
        minSide,
        minSide, // região de corte
        0,
        0,
        size,
        size // destino redimensionado
      );
      const mimeType = imageSrc?.type || "image/png";
      const outputExt = mimeType.split("/")[1];
      canvas.toBlob((blob) => {
        if (!blob) return reject(new Error("Falha ao criar blob"));
        const dataUrl = canvas.toDataURL(mimeType);
        resolve({ src: dataUrl, blob, ext: outputExt });
      }, mimeType);
    };
    image.onerror = reject;
  });
};

export { validateFile, resizeImage, cropImageCenter };
